import { render } from "./StatsGoals.vue?vue&type=template&id=cc51ce6c&scoped=true"
import script from "./StatsGoals.vue?vue&type=script&lang=js"
export * from "./StatsGoals.vue?vue&type=script&lang=js"

import "./StatsGoals.vue?vue&type=style&index=0&id=cc51ce6c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc51ce6c"]])

export default __exports__